var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "date-range-filter"
  }, [_vm.typeOptions.length ? _c('el-select', {
    staticClass: "type-select",
    attrs: {
      "placeholder": _vm.$t('sc.afterSaleNew.all')
    },
    model: {
      value: _vm.internalType,
      callback: function ($$v) {
        _vm.internalType = $$v;
      },
      expression: "internalType"
    }
  }, _vm._l(_vm.typeOptions, function (item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    });
  }), 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "shortcut-btns"
  }, _vm._l(_vm.timeList, function (item, index) {
    return _c('el-button', {
      key: 'date_range_' + index,
      class: {
        'no-check-btn': _vm.shortcut !== item.value
      },
      attrs: {
        "type": _vm.shortcut === item.value ? 'primary' : '',
        "plain": ""
      },
      on: {
        "click": function ($event) {
          return _vm.handleDateRangeChange(item.value);
        }
      }
    }, [_vm._v("\n      " + _vm._s(item.label) + "\n    ")]);
  }), 1), _vm._v(" "), _c('el-date-picker', _vm._b({
    staticClass: "date-picker-div",
    attrs: {
      "type": "daterange",
      "range-separator": "-",
      "value-format": "yyyy-MM-dd"
    },
    on: {
      "change": _vm.handleDateChange
    },
    model: {
      value: _vm.internalValue,
      callback: function ($$v) {
        _vm.internalValue = $$v;
      },
      expression: "internalValue"
    }
  }, 'el-date-picker', _vm.$attrs, false))], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }